import _ from 'lodash';
import NamedDto from 'modules/base/dto/NamedDto';

export default class DeviceTypeTableDto extends NamedDto {
	constructor() {
		super();

		/** @type {NamedDto[]} */
		this.sensorTypeList = null;

		/** @type {boolean} */
		this.bridge = null;

		/** @type {NamedDto} */
		this.project = null;

		/** @type {boolean} */
		this.canRecord = null;

		/** @type {number} */
		this.externalId = null;
	}

	/**
	 * @typedef {Object} _DeviceTypeTableDtoProps
	 * @property {NamedDto[]} sensorTypeList
	 * @property {boolean} bridge
	 * @property {NamedDto} project
	 * @property {boolean} canRecord
	 * @property {number} externalId
	 *
	 * @typedef {import("../NamedDto").NamedDtoProps & _DeviceTypeTableDtoProps} DeviceTypeTableDtoProps
	 */
	/**
	 *
	 * @param {DeviceTypeTableDtoProps} props
	 * @returns {DeviceTypeTableDto}
	 */
	setup(props) {
		super.setup(props);

		this.sensorTypeList = props.sensorTypeList != null ? props.sensorTypeList.map(d => new NamedDto().setup(d)) : [];
		this.bridge = props.bridge;
		this.project = props.project !== null ? new NamedDto().setup(props.project) : null;
		this.canRecord = props.canRecord;
		this.externalId = props.externalId;

		return this;
	}

	getAsString(key) {
		if (key === 'sensorTypeList')
			return _.isArray(this.sensorTypeList) ? this.sensorTypeList.map(d => d.name).join(', ') : '';
		return super.getAsString(key);
	}
}
